import React, { useState, useCallback } from "react";
import { useTheme, useMediaQuery } from "@mui/material";
import StyledDrawer from "./StyledDrawer";
import MimshakScatterCharts from "../../components/FeesLab/MimshakScatterCharts";
import { MimshakData } from "../../interfaces/DTO/mimshakData";

interface DrawerState {
  data: MimshakData[];
  title: string;
}

interface MimshakScatterDrawerResult {
  open: (data: MimshakData[], title: string) => void;
  drawer: React.ReactNode;
}

export function useMimshakScatterDrawer(): MimshakScatterDrawerResult {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [content, setContent] = useState<DrawerState | null>(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("md"));

  const open = useCallback((data: MimshakData[], title: string) => {
    setContent({ data, title });
    setDrawerOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setDrawerOpen(false);
  }, []);

  const drawer = content ? (
    <StyledDrawer
      anchor="left"
      open={drawerOpen}
      onClose={handleClose}
      onBack={handleClose}
      width={isSmallScreen ? undefined : 1300}
    >
      <MimshakScatterCharts
        mimshakData={content.data}
        title={content.title}
      />
    </StyledDrawer>
  ) : null;

  return { open, drawer };
}
